import ROLESDISTRIBUTION from 'data/mantechcar24/roles-distribution.json';
import { ResponsiveContainer, Tooltip, Treemap } from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';

const RolesDistribution: React.FC = () => {
  const COLORS = [
    '#08306B',
    '#081D58',
    '#0868AC',
    '#08519C',
    '#253494',
    '#2B8CBE',
    '#2171B5',
    '#50B4D3',
    '#4292C6',
    '#1D91C0',
    '#7BCCC4',
    '#41B6C4',
    '#6BAED6',
    '#A8DDB5'
  ];

  const CustomContent = ({
    root,
    x,
    y,
    width,
    height,
    index,
    colors,
    name
  }: any): any => {
    return (
      <g>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          style={{
            fill: colors[Math.floor((index / root.children.length) * 14)],
            stroke: '#fff',
            strokeWidth: 1
          }}
        />
        <foreignObject x={x + 5} y={y} width={width} height={height}>
          <p
            style={{
              color: '#fff',
              fontSize: '12px',
              fontWeight: 500,
              marginRight: '5px',
              marginTop: '10px',
              lineHeight: 1.2,
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {name}
          </p>
        </foreignObject>
      </g>
    );
  };

  return (
    <div>
      <StyledRecharts className="treemap">
        <ResponsiveContainer width="99%" height={450} minWidth={500}>
          <Treemap
            data={ROLESDISTRIBUTION}
            aspectRatio={16 / 9}
            nameKey="name"
            stroke="#fff"
            fill="#FFF8DF"
            content={<CustomContent colors={COLORS} />}
          >
            <Tooltip
              cursor={{ fill: '#ebe8df' }}
              formatter={(value: number, name: string) => [
                value.toFixed(1) + '%',
                name
              ]}
            />
          </Treemap>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default RolesDistribution;
